import { scrollToElement } from '../../../helpers/utils.js';

const getElementTemplate = ({ titleText = '', id = '' }) => `
    <a @click.prevent="scrollToElement('${id}')"
         href="#${id}"
         class="w-full block max-w-[546px] bg-white p-4 lg:px-8 lg:py-3 text-sm lg:text-md mb-2 shadow-base rounded-2xl cursor-pointer">
        <span>${titleText}</span>
    </a>
`;

export default function () {
    return {
        init() {
            const titles = Array.from(
                document.querySelectorAll('.sw-post-content h2')
            );

            titles.forEach((title) => {
                const element = document.createElement('div');
                const titleText = title.innerText;
                const id = title.querySelector('a')?.getAttribute('id') || '';

                element.innerHTML = getElementTemplate({ titleText, id });

                this.$el.appendChild(element);
            });
        },

        scrollToElement(id) {
            if (!id) return;

            scrollToElement(`#${id}`, { offset: -100 });
        }
    };
}
